import style from "./SignUpStepsCard.module.scss"


export default function SignUpStepsCard({key, icon, title, subTitle, currentPage, currentStep}) {
    return (
        <>
            <div className={`${style.signUpItemContainer} ${currentPage && style.signUpItemContainerActive}`} key={key}>
                <div className={style.signUpItemContent}>
                    <div className={style.iconContainer}>
                        <div className={icon}/>
                    </div>
                    <div className={style.signUpItemDescription}>
                        <div className={style.signUpItemTitle}>
                            {title}
                        </div>
                        <div className={style.signUpItemSubTitle}>
                            {subTitle}
                        </div>
                    </div>
                </div>
                <div
                    className={currentPage ? style.iconTickContainerActive :
                        currentStep ? style.iconTickContainerCurrent : style.iconTickContainerInactive}>
                    <div className={currentPage ? "ic-tick-active" :
                        currentStep ? "ic-tick-active" : "ic-tick-inactive"}/>
                </div>
            </div>
        </>

    )
}